<div class="modal-header">
    <h4 class="modal-title">Supprimer la session</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>
        Êtes-vous sûr de vouloir supprimer la session <strong>{{ examSession.code }}</strong> ?
    </p>
    <p>
        Un email de notification sera envoyé aux personnes concernées.
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-outline-danger" (click)="submit()" [disabled]="submitting">
        <span *ngIf="submitting" class="button-loader"></span>
        Supprimer
    </button>
</div>
